import type { CSSProperties } from 'react'

interface TriggerRect {
  left: number
  top: number
  bottom: number
  width: number
}

interface ViewportSize {
  width: number
  height: number
}

export function searchableUserMenuStyle(rect: TriggerRect, viewport: ViewportSize, cssZoom = 1): CSSProperties {
  const zoom = Number.isFinite(cssZoom) && cssZoom > 0 ? cssZoom : 1
  const viewportWidth = viewport.width / zoom
  const viewportHeight = viewport.height / zoom
  const logicalRect = {
    left: rect.left / zoom,
    top: rect.top / zoom,
    bottom: rect.bottom / zoom,
    width: rect.width / zoom,
  }
  const width = Math.min(Math.max(270, logicalRect.width), Math.max(270, viewportWidth - 20))
  const left = Math.min(Math.max(10, logicalRect.left), Math.max(10, viewportWidth - width - 10))
  const roomBelow = viewportHeight - logicalRect.bottom - 12
  const opensAbove = roomBelow < 220 && logicalRect.top > roomBelow

  return opensAbove
    ? { width, left, bottom: viewportHeight - logicalRect.top + 5, maxHeight: Math.max(120, Math.min(330, logicalRect.top - 15)) }
    : { width, left, top: logicalRect.bottom + 5, maxHeight: Math.max(120, Math.min(330, roomBelow)) }
}
